import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

const CashierBaseUrl = `${SELLER_V1_BASE}/cashiers`;

const listParams = (params = {}) => {
  const { page, limit, sort, order, status, is_active } = params;
  return {
    ...(page != null && { page }),
    ...(limit != null && { limit }),
    ...(sort != null && { sort: sort === 'ASC' ? 'ASC' : 'DESC' }),
    ...(order != null && { order }),
    ...(status != null && status !== 'all' && { status }),
    ...(is_active != null && { is_active }),
  };
};

export const sellerCashiersService = {
  getCashiers: async (params = {}) => {
    const q = listParams(params);
    const response = await api.get(CashierBaseUrl, { params: q });
    return response.data;
  },

  searchCashiers: async (params = {}) => {
    const { page, limit, search, status, ...rest } = params;
    const q = {
      ...(page != null && { page }),
      ...(limit != null && { limit }),
      ...(search != null && search !== '' && { search }),
      ...(status != null && status !== '' && status !== 'all' && { status }),
      ...rest,
    };
    const response = await api.get(`${CashierBaseUrl}/search`, { params: q });
    return response.data;
  },

  getCashierDetails: async (cashierId) => {
    const response = await api.get(`${CashierBaseUrl}/${cashierId}`);
    return response.data;
  },

  createCashier: async (cashierData) => {
    const response = await api.post(`${CashierBaseUrl}/create`, cashierData);
    return response.data;
  },

  updateCashier: async (cashierId, cashierData) => {
    const url = `${CashierBaseUrl}/${cashierId}`;
    const response = await api.put(url, cashierData);
    return response.data;
  },

  deleteCashier: async (sellerId, cashierId) => {
    const response = await api.delete(`${CashierBaseUrl}/${sellerId}/${cashierId}`);
    return response.data;
  },

  updateCashierStatus: async (cashierId, status) => {
    const response = await api.patch(
      `${CashierBaseUrl}/${cashierId}/status`,
      {},
      { params: { status } }
    );
    return response.data;
  },

  getCashierActivity: async (sellerId, cashierId, params = {}) => {
    const response = await api.get(`${CashierBaseUrl}/${sellerId}/${cashierId}/transaction-history`, { params });
    return response.data;
  },

  getCashierTransactions: async (cashierId, options = {}) => {
    const { signal, params = {}, ...rest } = options;
    const requestConfig = { params, ...rest };
    if (signal) requestConfig.signal = signal;
    const response = await api.get(`${CashierBaseUrl}/${cashierId}/transactions`, requestConfig);
    return response.data;
  },

  getCashierStats: async () => {
    const response = await api.get(`${CashierBaseUrl}/stats`);
    return response.data;
  },
};

export default sellerCashiersService;
